import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import PropTypes from 'prop-types'
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import {Divider, Grid, Typography} from '@mui/material'
import dayjs from 'dayjs'
import ButtonWithIcon from "../Button/Button"

const DateRangeModal = (props) => {

  const [firstDate, setFirstDate] = useState(dayjs(new Date()))
  const [secondDate, setSecondDate] = useState(dayjs(new Date()))

  useEffect(() => {
    if (props.value) {
      const newValue = dayjs(props.value)
      setFirstDate(newValue)
      setSecondDate(newValue)
    }
  }, [props.value])

  const changeFirstDate = (value) => {
    setFirstDate(value)
  }

  const changeSecondDate = (value) => {
    setSecondDate(value)
  }

  const returnValue = () => {
    if (props.callback) {
      props.callback(firstDate, secondDate)
    }
  }

  return <div>
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth={"md"}
    >
      <DialogTitle color="common.white" id="responsive-dialog-title">
        {"Selecione um intervalo"}
      </DialogTitle>
      <DialogContent>
        <Grid container direction="row" alignItems="flex-start" spacing={2}>
          <Grid item>
            <Typography sx={{ color: "#fff", mb: 1 }} variant="body2">
              Data Inicial
            </Typography>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar value={firstDate} onChange={changeFirstDate} />
            </LocalizationProvider>
          </Grid>

          <Divider orientation="vertical" flexItem />

          <Grid item>
            <Typography sx={{ color: "#fff", mb: 1 }} variant="body2">
              Data Final
            </Typography>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                  value={secondDate}
                  minDate={firstDate}
                  onChange={changeSecondDate}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.onClose} sx={{color: "common.white"}}>
          Voltar
        </Button>
        <ButtonWithIcon size={"md"} autoFocus variant='contained' onClick={returnValue}>
          Aplicar
        </ButtonWithIcon>
      </DialogActions>
    </Dialog>
  </div>

}

DateRangeModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  value: PropTypes.string,
  callback: PropTypes.func
}


export default DateRangeModal
